import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["groupSection", "chevron", "itemsList"]
  static values = {
    groupId: Number,
    activeGroupId: Number
  }

  connect() {
    console.log("SidebarAccordionController connected")
    this.restoreExpandedStates()

    if (this.hasActiveGroupIdValue && this.activeGroupIdValue) {
      this.expandGroup(this.activeGroupIdValue)
    }
  }

  toggleGroup(event) {
    event.preventDefault()
    const groupId = event.currentTarget.dataset.groupId

    if (this.isExpanded(groupId)) {
      this.collapseGroup(groupId)
    } else {
      this.expandGroup(groupId)
    }

    this.saveExpandedStates()
  }

  expandGroup(groupId) {
    const section = this.findGroupSection(groupId)
    if (!section) return

    const itemsList = section.querySelector('[data-sidebar-accordion-target="itemsList"]')
    const chevron = section.querySelector('[data-sidebar-accordion-target="chevron"]')

    if (itemsList) {
      itemsList.classList.remove('hidden')
    }

    if (chevron) {
      chevron.classList.add('rotate-90')
    }

    section.dataset.expanded = 'true'
  }

  collapseGroup(groupId) {
    const section = this.findGroupSection(groupId)
    if (!section) return

    const itemsList = section.querySelector('[data-sidebar-accordion-target="itemsList"]')
    const chevron = section.querySelector('[data-sidebar-accordion-target="chevron"]')

    if (itemsList) {
      itemsList.classList.add('hidden')
    }

    if (chevron) {
      chevron.classList.remove('rotate-90')
    }

    section.dataset.expanded = 'false'
  }

  isExpanded(groupId) {
    const section = this.findGroupSection(groupId)
    return section?.dataset.expanded === 'true'
  }

  findGroupSection(groupId) {
    return this.groupSectionTargets.find(
      section => section.dataset.groupId === String(groupId)
    )
  }

  saveExpandedStates() {
    const expandedGroups = this.groupSectionTargets
      .filter(section => section.dataset.expanded === 'true')
      .map(section => section.dataset.groupId)

    sessionStorage.setItem('expandedGroups', JSON.stringify(expandedGroups))
  }

  restoreExpandedStates() {
    const stored = sessionStorage.getItem('expandedGroups')
    if (!stored) return

    try {
      const expandedGroups = JSON.parse(stored)
      expandedGroups.forEach(groupId => {
        this.expandGroup(groupId)
      })
    } catch (e) {
      console.error('Failed to restore expanded states:', e)
    }
  }

  disconnect() {
    this.saveExpandedStates()
  }
}